import React, { useEffect, useState } from 'react'
import { useSpring, animated } from 'react-spring'

interface SlideProps {
  children: React.ReactNode
  isVisible: boolean
  id: string
  className: string
}

const Slide: React.FC<SlideProps> = ({
  children,
  isVisible,
  id,
  className
}) => {
  const [display, setDisplay] = useState(isVisible ? 'block' : 'none')
  const isOnLeft = className.includes('overlay-left')

  useEffect(() => {
    if (isVisible) {
      setDisplay('block')
    }
  }, [isVisible])

  const animation = useSpring({
    transform: isOnLeft
      ? isVisible
        ? 'translateX(0%)'
        : 'translateX(-100%)'
      : isVisible
      ? 'translateX(0%)'
      : 'translateX(100%)',
    display,
    config: {
      duration: 300
    },
    onRest: () => {
      if (!isVisible) {
        setDisplay('none')
      }
    }
  })

  return (
    <animated.section style={animation} id={id} className={className}>
      {children}
    </animated.section>
  )
}

export default Slide
